<template>
  <div class="auth-users">
    <el-form label-width="0px" :inline="true">
      <el-form-item label="" prop="wkNo">
        <el-input type="text" v-model="searchText" autocomplete="on" class="auth-input" placeholder="姓名/工号，搜索表格数据" clearable></el-input>
        <el-button type="primary" class="auth-btn" native-type="submit" @click.prevent="queryUserList" plain>搜索</el-button>
      </el-form-item>

      <el-form-item label="" prop="newWkNo" style="margin-left: 10px;">
        <selecter v-model="newWkNo" @selecterData="getSelecterWkNameData" class="auth-input"></selecter>
        <el-tooltip effect="dark" v-if="!newWkNo" content="请先选择用户" placement="top">
          <el-button type="primary" class="auth-btn" disabled>添加</el-button>
        </el-tooltip>
        <el-button v-else type="primary" class="auth-btn" @click="addNew()">添加</el-button>
      </el-form-item>
      <el-form-item class="paste-form-item">
        <el-input
          type="textarea"
          :autosize="{ maxRows: 1 }"
          resize="none"
          v-model="pasteText"
          class="paste-text-input"
          placeholder="从Excel中复制姓名工号，粘贴到此处，点击确定。工号为第一列，姓名为第二列"
        >
        </el-input>
        <el-button @click="patseText()" type="primary" class="auth-btn">批量添加</el-button>
      </el-form-item>
    </el-form>
    <vxe-table
      row-key
      column-key
      show-overflow
      show-header-overflow
      highlight-hover-row
      highlight-current-row
      auto-resize
      height="360"
      v-loading="loading"
      ref="userTable"
      :scroll-y="{gt: 50, oSize: 5}" 
      :data="tableData"
      :keyboard-config="{isArrow: true}"
    >
      <vxe-column type="seq" title="序号" fixed="left" width="100"></vxe-column>
      <vxe-column field="wkNo" :formatter="nameFormat" type="html" title="工号"></vxe-column>
      <vxe-column field="wkName" :formatter="nameFormat" type="html" title="姓名"></vxe-column>
      <vxe-column field="" title="操作" fixed="right" width="60" class-name="operation">
        <template #default="scope">
          <div>
            <!-- <el-popover
              placement="top"
              width="120"
              v-model="row.visibleDelete"
            >
              <p style="margin-bottom: 12px;">确定删除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="cancelDel(row)">取消</el-button>
                <el-button type="primary" size="mini" @click="confirmDel(row, rowIndex)">确定</el-button>
              </div>
              <span slot="reference"><i class='icon-close delete' @click.stop='deleteRow(row, rowIndex)'></i></span>
            </el-popover> -->
            <i class='icon-close delete' @click.stop='deleteRow(scope.row, scope.rowIndex)'></i>
          </div>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="atb-text-right" style="margin-top: 10px;">
      <el-button class="atb-dialog-confirm" type="primary" @click="removeAll">全部删除</el-button>
      <!-- 保存 -->
      <el-button class="atb-dialog-confirm" type="primary" @click="submit" style="margin-left: 0;">保存</el-button>
      <!-- 取消 -->
      <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
    </div>
  </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
export default {
  name: 'UserAuth',
  mixins: [ editMixin ],
  components: {
    selecter:()=>import('@/component/global/customerSelect')
  },
  props: {
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {
        newWkNo: [
          { required: true, message: '请选择新增用户', trigger: 'change' },
        ]
      },
      loading: false,
      editForm: { wkNos: []},
      initselectData: [],
      isLoaded: false,
      searchText: '',
      tableAllData: [],
      tableData: [],
      wkNo: [],
      newWkNo: '',
      newWkName: '',
      seleterWkNameData: [],

      userKeyMap: {},

      pasteText: '',

    }
  },
  created() {
    this.getUsers();
  },
  methods: {
    validatea(evt) {
      var theEvent = evt || window.event;
      var key = theEvent.charCode || theEvent.which;

      if(key >= 32 && (theEvent.ctrlKey === undefined || !theEvent.ctrlKey)) {
        if(theEvent.preventDefault) theEvent.preventDefault();
        else theEvent.returnValue = false;
      }
    },
    getUsers() {
      this.$ajax.get(this.$api.Identity.Groups.users, { groupId: this.editData.id }).then((res) => {
        let list = res.data || [];
        list.forEach(item => {
          item.visibleDelete = false;
        });
        this.tableAllData = this.tableData = list;
        this.$nextTick(() => {
          this.tableAllData.forEach(item => {
            this.userKeyMap[item.wkNo] = item.wkName;
          });
        });
      }).finally(() => {
        this.isLoaded = true;
      });
    },
    getSelecterWkNameData(data){
      this.seleterWkNameData = data;
    },
    submit() {
      let wkNos = [];
      this.tableAllData.forEach(item => {
        wkNos.push(item.wkNo);
      });
      this.$ajax.post(this.$api.Identity.Groups.updateUsers, {groupId: this.editData.id, wkNos}).then(() => {
        this.$message.success('保存成功');
        this.$parent.$parent.hide();
      });
    },
    // 添加用户时，获取所有用户，打开弹窗，选择用户
    queryUserList() {
      const self = this;
      const tableAllData = this.tableAllData;
      this.loading = true;      

      const endFn = function() {
        self.loading = false;   
        setTimeout(() => {
          self.$refs['userTable'] && self.$refs['userTable'].scrollTo(0, 0);
        }, 0)
      }

      this.tableData = tableAllData.filter(v => {
        let reg = new RegExp(this.searchText, 'gi');
        return reg.test(v.wkName) || reg.test(v.wkNo);
      })
      endFn();
      
    },
    nameFormat({ cellValue }) {
      let keyword = this.searchText;
      if(keyword) {
        return this.highlight(cellValue, [keyword], 'span');
      } else {
        return cellValue;
      }
    },
    highlight(text, words, tag) {
      tag = tag || 'span';
      Array.prototype.forEach.call(words, function(v, i) {
        let reg = new RegExp(words[i], 'gi');
        if (reg.test(text)) {
          text = text.replace(reg, '<'+ tag +' class="light">$&</'+ tag +'>');
        }
      })
      return text;
    },
    deleteRow(row, rowIndex) {
      // row.visibleDelete = true;
      this.confirmDel(row, rowIndex);
    },

    confirmDel(row, rowIndex) {
      let index = this.tableAllData.findIndex((item) => item.wkNo === row.wkNo);
      index !== -1 && this.tableAllData.splice(index, 1);
      if (this.tableAllData !== this.tableData) {
        this.tableData.splice(rowIndex, 1);
        // this.$refs.userTable.remove(row);
      }
      row.visibleDelete = false;
      this.userKeyMap[row.wkNo] = null;
    },

    cancelDel(row) {
      row.visibleDelete = false;
    },
    // 添加新用户
    addNew() {
      this.newWkName = this.newWkNo ? this.seleterWkNameData.find(t => t.jobNo == this.newWkNo).name: '';
      if (this.userKeyMap[this.newWkNo]) {
        this.$message.error('用户已存在');
        return false;
      }
      this.tableAllData.unshift({
        wkNo: this.newWkNo,
        wkName: this.newWkName,
        visibleDelete: false
      });
      this.tableData = this.tableAllData;
      this.userKeyMap[this.newWkNo] = this.newWkName;

      this.searchText = '';
    },
    removeAll() {
      this.tableAllData = this.tableData = [];
      this.searchText = '';
      this.userKeyMap = {};
    },
    patseText() {
      try {
        let copyiedText = this.pasteText;
        copyiedText = copyiedText.trim();
        if (!copyiedText) {
          this.$message.error('粘贴的文本为空')
          return false;
        }
        if (!copyiedText.includes('\t')) {
          this.$message.error('文本格式错误，请检查格式并重试')
          return false;
        }
        let copiedList = copyiedText.split('\n');
        let copiedNum = copiedList.length;
        let repeatNum = 0;
        let cpoiedUsers = [];
        for (let i = 0; i < copiedList.length; i++) {
          let itemStr = copiedList[i].trim();
          if (itemStr) {
            let userItem = itemStr.split('\t');
            if (this.userKeyMap[userItem[0]]) {
              repeatNum++;
              continue;
            }
            cpoiedUsers.push({
              wkNo: userItem[0],
              wkName: userItem[1],
              visibleDelete: false
            });
          }
        }

        console.log(cpoiedUsers);
        this.tableAllData.unshift(...cpoiedUsers);
        this.tableData = this.tableAllData;

        this.searchText = '';
        this.$nextTick(() => {
          this.tableAllData.forEach(item => {
            this.userKeyMap[item.wkNo] = item.wkName;
          });
          if (repeatNum === 0) {
            this.$message.success(`已添加${copiedNum - repeatNum}个用户`);
          } else {
            this.$message.success(`已添加${copiedNum - repeatNum}个用户，其中${repeatNum}个用户已存在`);
          }
        });
      } catch (error) {
        this.$message.error('文本解析错误，请检查格式并重试')
      }
   
    },
    
  }
}
</script>
<style lang="scss">
  .light {
    color: $--color-primary;
  }
  .auth-users {
    .el-form-item {
      margin-bottom: 16px;
    }
    .icon-close {
      color: red;
      cursor: pointer;
    }
    .auth-input {
      width: 240px;
      .el-input__inner {
        border-top-right-radius: 0; 
        border-bottom-right-radius: 0; 
      }
    }
    .auth-btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .paste-form-item {
      width: 640px;
      .el-form-item__content {
        width: 100%;
      }
      .paste-text-input {
        width: calc(100% - 98px);
        .el-textarea__inner {
          border-top-right-radius: 0; 
          border-bottom-right-radius: 0; 
          height: 40px!important;
          line-height: 27px;
        }
      }
    }
  }
</style>
